import apiClient from "config/apiClient";
import { PaginationParamType } from "type";
import { Csv, CsvDownload } from "../types/csv";

interface ResponseCsvList {
  list: Csv[];
  total: number;
}

/**
 *  Get CSV list
 * @param body CsvQuery
 */
export const getCsvApi = async (body?: PaginationParamType) => {
  const res = await apiClient.post<ResponseCsvList>("/mst/csv/upload/history", body);
  return { list: res.data?.list || [], total: res.data?.total || 0 };
};

export const uploadCsv = async (file: File | null, type: string) => {
  if (!file) {
    throw new Error("File is required");
  }

  const formData = new FormData();
  formData.append("case", type);
  formData.append("file", file);

  try {
    const res = await apiClient.post("/mst/csv/upload", formData, {
      "Content-Type": "multipart/form-data",
    });
    return { data: res.data, status: res.status };
  } catch (error) {
    throw new Error(`Upload failed: ${error}`);
  }
};

/**
 * Fetches the CSV download history from the server.
 *
 * @returns {Promise<CsvDownload>} A promise that resolves to the CSV download history data.
 */
export const getCsvDownloadApi = async () => {
  const res = await apiClient.post<CsvDownload>("/mst/csv/download", {});
  return res.data;
};
